export enum EEPIType {
    Aucun = 1,
    DemiMasqueFP10 = 2,
    TM3PFP60 = 3,
    AdductionFP250 = 4
}